export default __webpack_public_path__ + "static/media/dark_small.fc4d0db6.png";